<div class="center" (click)="onClick(this)">
  <div #checkbox class="ag-selection-checkbox fl" unselectable="on">
    <span class="ag-icon ag-icon-checkbox-checked ag-hidden" unselectable="on"></span>
    <span class="ag-icon ag-icon-checkbox-unchecked" unselectable="on"></span>
  </div>
  <div class="fl ml5 pt2">{{params.displayName}}</div>
</div>